/**
 * Authentication-related constants
 */

/**
 * Hardcoded admin email addresses that should have superuser access
 * This is a fallback for cases where custom claims haven't been set yet
 * 
 * These emails are checked in addition to the `isSuperAdmin` custom claim
 * to provide superuser access even if custom claims haven't been set.
 */
export const SUPERUSER_EMAILS = [
  "ben.schell@ohc400.org",
  "jason.paris@ohc400.org",
  "ben@hubara.app",
  "jason@hubara.app",
  "ben.schell@gmail.com",
  "jason@parisleatherworks.com",
] as const;

/**
 * Type for superuser email addresses
 */
export type SuperuserEmail = (typeof SUPERUSER_EMAILS)[number];

